module.exports = __webpack_public_path__ + "media/bg_video.1114a6df.mp4";